import { render, staticRenderFns } from "./clientmodale.vue?vue&type=template&id=f44d6134&scoped=true"
import script from "./clientmodale.vue?vue&type=script&lang=js"
export * from "./clientmodale.vue?vue&type=script&lang=js"
import style0 from "./clientmodale.vue?vue&type=style&index=0&id=f44d6134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44d6134",
  null
  
)

export default component.exports